import type { ReactNode, ButtonHTMLAttributes } from "react";
import { Link, type LinkProps } from "react-router-dom";

export type ClickableProps<T = object> = T &
  Omit<ButtonHTMLAttributes<HTMLButtonElement>, keyof T | "to" | "target"> & {
    to?: LinkProps["to"];
    target?: string;
    children?: ReactNode;
    className?: string;
  };

export function renderClickable<T>({
  to,
  target,
  disabled,
  content,
  className,
  props,
}: {
  to?: LinkProps["to"];
  target?: string;
  disabled?: boolean;
  content: ReactNode;
  className: string;
  props: T;
}): ReactNode {
  if (to && !disabled) {
    return (
      <Link to={to} target={target} className={className}>
        {content}
      </Link>
    );
  }

  return (
    <button
      type="button"
      disabled={disabled}
      className={className}
      {...(props as ButtonHTMLAttributes<HTMLButtonElement>)}
    >
      {content}
    </button>
  );
}
